import React, { useRef } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { getColourSettings } from '../utils/mapStyles';
import './FurthestDistanceMarker.css';

function FurthestDistanceMarker({ record, colourSettings, onSelect }) {
  const position = [record.latitude, record.longitude];
  const markerRef = useRef(null);

  // Get colour settings (use prop if provided, otherwise load from localStorage)
  const colours = colourSettings || getColourSettings();
  // Use the same colour as the range outline for consistency
  const dotColor = colours.maxDistanceOutline;

  // Create a custom dot icon using divIcon
  // Use larger touch target on touch devices (44px is Apple's minimum recommended)
  const isTouchDevice = typeof window !== 'undefined' &&
    ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  const touchTargetSize = isTouchDevice ? 44 : 10;
  const dotSize = isTouchDevice ? 14 : 10;

  const dotIcon = L.divIcon({
    html: `<div style="
      width: ${touchTargetSize}px;
      height: ${touchTargetSize}px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      pointer-events: auto;
    "><div style="
      width: ${dotSize}px;
      height: ${dotSize}px;
      background-color: ${dotColor};
      border-radius: 50%;
      box-shadow: 0 1px 3px rgba(0,0,0,0.4);
      pointer-events: auto;
    "></div></div>`,
    iconSize: [touchTargetSize, touchTargetSize],
    iconAnchor: [touchTargetSize / 2, touchTargetSize / 2],
    className: 'furthest-distance-dot'
  });

  // Handle click - select this range record to show popup
  const handleClick = (e) => {
    // Prevent map click from propagating
    if (e.originalEvent) {
      e.originalEvent.stopPropagation();
    }
    // Call onSelect callback to show popup
    if (onSelect) {
      onSelect(record);
    }
  };

  return (
    <Marker
      ref={markerRef}
      position={position}
      icon={dotIcon}
      pane="furthestDistancePane"
      eventHandlers={{
        click: handleClick
      }}
    />
  );
}

export default React.memo(FurthestDistanceMarker);
